import React from 'react';

export default ({ content }) => (
    <ul className="unordered-list">
        {content.map((item, index) => {
            return (
                <li key={index} className="unordered-list__item">
                    {item}
                </li>
            );
        })}
    </ul>
);



// WEBPACK FOOTER //
// ./src/components/ui/unordered-list.js